import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import RequestForSignetApprovalForm from './CreationForm/RequestForSignetApprovalForm';
import { clearPlaceList } from '../../actions/place';
import {
  findAllMunicipalityByPlace,
  clearMunicipalityList,
} from '../../actions/municipality';
import { findAllInstitutionType } from '../../actions/institutionType';
import { findAllKjsByInstitutionType, clearKjsList } from '../../actions/kjs';
import { findAllRequestForSignetApprovalAttachments } from '../../actions/requestForSignetApproval';
import { findUserById } from '../../actions/user';
import ErrorHandler from '../Reusable/ErrorHandler';

class ModalForRequestForSignetApprovalUpdateAndPreview extends React.Component {
  handleClose = () => {
    this.props.handleClose();
  };

  componentDidMount() {
    const {
      requestForSignetApproval,
      findAllInstitutionType,
      findAllKjsByInstitutionType,
      findAllMunicipalityByPlace,
      findAllRequestForSignetApprovalAttachments,
    } = this.props || {};
    const { kjs } = requestForSignetApproval || {};
    const { municipality, institutionType } = kjs || {};
    const { place } = municipality || {};

    findAllInstitutionType();
    findAllKjsByInstitutionType(institutionType?.id);
    findAllMunicipalityByPlace(place?.id);
    findAllRequestForSignetApprovalAttachments(
      this.props.requestForSignetApproval.id
    );
  }

  render() {
    const {
      requestForSignetApproval,
      autonomousProvinceList,
      placeList,
      municipalityList,
      kjsList,
      institutionTypeList,
      isPreview,
      handleAdd,
      requestForSignetApprovalAttachmentList,
      downloadAttachment,
      error,
      deleteError,
      user,
      findUserById,
      loggedUser,
    } = this.props || {};

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <ErrorHandler error={error} deleteError={deleteError} />
            <RequestForSignetApprovalForm
              autonomousProvinceList={autonomousProvinceList}
              placeList={placeList}
              municipalityList={municipalityList}
              kjsList={kjsList}
              institutionTypeList={institutionTypeList}
              isPreview={isPreview}
              requestForSignetApproval={requestForSignetApproval}
              handleAdd={handleAdd}
              findAllMunicipalityByPlace={this.props.findAllMunicipalityByPlace}
              findAllKjsByInstitutionType={
                this.props.findAllKjsByInstitutionType
              }
              clearPlaceList={this.props.clearPlaceList}
              clearMunicipalityList={this.props.clearMunicipalityList}
              clearKjsList={this.props.clearKjsList}
              requestForSignetApprovalAttachmentList={
                requestForSignetApprovalAttachmentList
              }
              handleClose={this.handleClose}
              downloadAttachment={downloadAttachment}
              loggedUser={loggedUser}
              findUserById={findUserById}
              user={user}
            />
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  autonomousProvinceList: state.autonomousProvince.autonomousProvinceList || [],
  placeList: state.place.placeList || [],
  municipalityList: state.municipality.municipalityList || [],
  kjsList: state.kjs.kjsList || [],
  institutionTypeList: state.institutionType.institutionTypeList || [],
  user: state.user.user,
  loggedUser: state.loggedUser.loggedUser,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllMunicipalityByPlace: (placeId) => {
      dispatch(findAllMunicipalityByPlace(placeId));
    },
    findAllInstitutionType: () => {
      dispatch(findAllInstitutionType());
    },
    findAllKjsByInstitutionType: (institutionTypeId) => {
      dispatch(findAllKjsByInstitutionType(institutionTypeId));
    },
    clearPlaceList: () => {
      dispatch(clearPlaceList());
    },
    clearMunicipalityList: () => {
      dispatch(clearMunicipalityList());
    },
    clearKjsList: () => {
      dispatch(clearKjsList());
    },
    findAllRequestForSignetApprovalAttachments: (
      requestForSignetApprovalId
    ) => {
      dispatch(
        findAllRequestForSignetApprovalAttachments(requestForSignetApprovalId)
      );
    },
    findUserById: (userId) => {
      dispatch(findUserById(userId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalForRequestForSignetApprovalUpdateAndPreview);
